export default {
  startTestInfo(state) {
    return state.startTestInfo;
  },
  loading(state) {
    return state.loading;
  },

  apiBaseUrl(state) {
    return state.app_apiURL;
  },
  currentTestId(state) {
    return state.currentTestId
  },
  currentDomainName(state) {
    return state.userCurrentDomainName;
  },
  testRoutingAllowed(state) {
    return state.testRoutingAllowed
  },
  defaultOrganizationIdForFlavor(state) {
    return state.app_defaultOrganizationIdForFlavor;
  }
};
